'use client';

import { useFormContext } from 'react-hook-form';

import { useToggle } from '@/hooks/use-toggle';

interface Props {
    id: string;
    label: string;
    onChange: (value: boolean) => void;
    name: string;
    align?: string;
    textCls?: string;
}

export const Checkbox = (props: Props) => {
    const { toggleValue, setToggleValue } = useToggle();

    const handleToggle = () => {
        setToggleValue(!toggleValue);
        props.onChange(!toggleValue);
    };

    const { register } = useFormContext();

    return (
        <div onChange={handleToggle} className={`relative flex justify-start`}>
            <input
                aria-label={`select ${props.label}`}
                checked={toggleValue}
                {...register(props.name)}
                id={props.id}
                type="checkbox"
                className="w-0 opacity-0"
            />
            <div
                onClick={handleToggle}
                className={`min-w-4 min-h-4 border-regular h-4 w-4 rounded bg-white bg-[length:.65rem_.65rem] bg-center bg-no-repeat p-[6px] ${
                    toggleValue ? 'bg-phiCheck' : ''
                }`}
            />
            <label
                className={`label -mt-1 ml-3 ${props.textCls}`}
                htmlFor={props.id}
                dangerouslySetInnerHTML={{ __html: props.label }}
            />
        </div>
    );
};
